// src/components/AboutUs.jsx
// Strona „O nas” - sygnały wiarygodności (E-E-A-T): kto prowadzi serwis,
// jak powstają treści, jak je aktualizujemy i gdzie weryfikować przepisy.
import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../css/modules/Page.module.css';
import JsonLd from '../seo/JsonLd';
import { breadcrumbJsonLd, CONTACT_EMAIL } from '../seo/siteMeta';

const AboutUs = () => (
  <>
    <JsonLd
      data={breadcrumbJsonLd([
        { name: 'Strona główna', path: '/' },
        { name: 'O nas', path: '/o-nas' },
      ])}
    />

    <main className={styles.page}>
      <article className={styles.wrap}>
        <nav className={styles.breadcrumbs} aria-label="Ścieżka nawigacji">
          <Link to="/">Strona główna</Link> › <span>O nas</span>
        </nav>

        <h1 className={styles.h1}>O serwisie Pilotuje.pl</h1>

        <p className={styles.lead}>
          Pilotuje.pl to polski serwis z testami online przygotowującymi do egzaminów
          teoretycznych dla pilotów: <strong>licencji PPL(A) i LAPL(A)</strong>, świadectwa
          kwalifikacji pilota samolotu ultralekkiego oraz uprawnień operatora bezzałogowca
          w podkategoriach A1/A3 i A2.
        </p>

        <section className={styles.section}>
          <h2>Po co powstał serwis</h2>
          <p>
            Teoria do PPL(A) to dziewięć osobnych egzaminów, każdy z progiem 75 procent, a
            materiał rozrzucony jest po rozporządzeniach unijnych, podręcznikach i notatkach
            z kursu. Do tego dochodzi presja czasu: przy 28 pytaniach z prawa lotniczego na
            45 minut wychodzi niecałe dwie minuty na pytanie, licząc z czytaniem treści.
          </p>
          <p>
            Zebraliśmy materiał w jednym miejscu i przy każdym pytaniu napisaliśmy, dlaczego
            dana odpowiedź jest poprawna i z jakiego przepisu to wynika. Poza spokojnym trybem
            nauki dajemy tryb pojedynku z ograniczonym czasem na odpowiedź - to on wyłapuje
            zagadnienia, które znasz teoretycznie, ale nie odruchowo.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Jak przygotowujemy materiały</h2>
          <ul>
            <li>
              <strong>Pytania są autorskie.</strong> Krajowy Bank Pytań ULC nie jest
              udostępniany publicznie, więc nikt uczciwie nie oferuje jego kopii. Nasze pytania
              napisaliśmy pod program egzaminacyjny wynikający z przepisów.
            </li>
            <li>
              Podstawą są rozporządzenie (UE) nr 1178/2011 (Part-FCL i Part-MED), rozporządzenie
              wykonawcze (UE) nr 923/2012 (SERA), rozporządzenie (UE) nr 965/2012 (Part-NCO),
              ustawa Prawo lotnicze oraz rozporządzenia 2019/945 i 2019/947 dla bezzałogowców.
            </li>
            <li>
              Przy każdej odpowiedzi podajemy wyjaśnienie i wskazanie przepisu - chodzi
              o zrozumienie zasady, a nie zapamiętanie litery odpowiedzi.
            </li>
            <li>
              Parametry organizacyjne egzaminu, czyli liczby pytań i limity czasu, podajemy za
              tabelą Krajowego Banku Pytań ULC. To dane, które urząd może zmienić komunikatem,
              dlatego wprost odsyłamy do aktualnego komunikatu Lotniczej Komisji Egzaminacyjnej.
            </li>
            <li>
              Śledzimy zmiany stanu prawnego. Przykład z tego roku: krajowe scenariusze NSTS
              przestały obowiązywać 31 grudnia 2025 roku, a w kategorii szczególnej stosuje się
              teraz europejskie scenariusze STS-01 i STS-02.
            </li>
            <li>
              Jeżeli znajdziesz błąd merytoryczny, napisz - poprawiamy i dopisujemy źródło.
            </li>
          </ul>
          <p className={styles.note}>
            Pilotuje.pl jest serwisem edukacyjnym. Nie jest oficjalną stroną Urzędu Lotnictwa
            Cywilnego, nie wydaje licencji, świadectw kwalifikacji ani certyfikatów i nie
            przeprowadza egzaminów. Nie zastępuje też aktualnych aktów prawnych - w sprawach
            formalnych potwierdzaj wymagania u organizatora egzaminu.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Kto prowadzi serwis</h2>
          <p>
            Właścicielem i administratorem serwisu jest <strong className="dane-adm-nazwa" />,{' '}
            <span className="dane-adm-adres" />. Kontakt:{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
          <p>
            Pełne zasady korzystania z serwisu opisuje <Link to="/regulamin">regulamin</Link>,
            a zasady przetwarzania danych -{' '}
            <Link to="/polityka-prywatnosci">polityka prywatności</Link>.
          </p>
        </section>

        <div className={styles.ctaBox}>
          <h2>Zacznij od darmowego testu</h2>
          <p>Sprawdź formę nauki bez rejestracji i bez opłat.</p>
          <div className={styles.ctaRow}>
            <Link to="/intro" className={styles.primaryButton}>
              Rozegraj darmowy test
            </Link>
            <Link to="/egzamin-teoretyczny-ulc" className={styles.secondaryButton}>
              Jak wygląda egzamin w ULC
            </Link>
          </div>
        </div>
      </article>
    </main>
  </>
);

export default AboutUs;
